import { Component, OnInit, Input } from '@angular/core';

import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UiFactory } from '../../core/ui/ui-factory';
import { CheckboxModel } from './checkbox-model';
import { BehaviorService } from '../../core/behavior/behavior.service';

@Component({
  selector: 'pg-checkbox-factory, grit-checkbox-factory',
  templateUrl: './pg-checkbox-factory.component.html',
  styleUrls: ['./pg-checkbox-factory.component.scss'],
})
export class PgCheckboxFactoryComponent extends UiFactory {
  @Input() parentFormGroup: FormGroup;

  @Input() model: any;

  get checkboxModel(): CheckboxModel {
    return this.model;
  }

  constructor(public behaviorService: BehaviorService) {
    super(behaviorService);
  }

  ngOnInit() {
    super.ngOnInit();
    if (!this.parentFormGroup) {
      throw new Error(
        'parentFormGroup is a required input for pg-checkbox-factory'
      );
    }

    let control = this.parentFormGroup.get(this.checkboxModel.formControlName);
    if (!control) {
      this.parentFormGroup.addControl(
        this.checkboxModel.formControlName,
        new FormControl()
      );
      control = this.parentFormGroup.get(this.checkboxModel.formControlName);
      if (this.checkboxModel.requiredTrue) {
        control.setValidators([Validators.requiredTrue]);
      }
    }
  }
}
